/* Friking — buscador interno de clubs (solo filtra las tarjetas de la página) */
(function () {
  'use strict';
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function init() {
    document.querySelectorAll('[data-fk-soc]').forEach(function (box) {
      if (box.getAttribute('data-ready')) return;
      box.setAttribute('data-ready', '1');
      var input = box.querySelector('.fk-soc__input'), cards = box.querySelectorAll('.fk-soc__card'), empty = box.querySelector('.fk-soc__empty');
      if (!input) return;
      input.addEventListener('input', function () {
        var q = norm(input.value).trim(), n = 0;
        cards.forEach(function (c) {
          var show = !q || norm(c.getAttribute('data-name')).indexOf(q) > -1;
          c.hidden = !show; if (show) n++;
        });
        if (empty) empty.hidden = n !== 0;
      });
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
